import { BaseModule } from "./base.module";

export class ClipboardModule extends BaseModule {
    initialize() {
        this.clipboardSelector = ".copy-to-clipboard";

        if (typeof window !== "undefined") window.addEventListener('DOMContentLoaded', () => {
            this.clipboardElements = document.querySelectorAll(this.clipboardSelector);
            this.setEventListeners();
        });
    }

    setEventListeners() {
        this.clipboardElements.forEach((element) => {
            element.addEventListener("click", (e) => this.handleClipboardClick(e, element));
        });
    }

    handleClipboardClick(e, clipboardElement) {
        e.preventDefault();
        const { clipboardData, clipboardSlug } = clipboardElement.dataset;
        this.writeTextToClipboard(clipboardElement, clipboardData, clipboardSlug);
    }

    async writeTextToClipboard(clipboardElement, text, clipboardSlug) {
        try {
            await navigator.clipboard.writeText(text);
            this.onWriteComplete(clipboardElement, clipboardSlug, "Gekopieerd");
        } catch (e) {
            this.onWriteComplete(clipboardElement, clipboardSlug, `Er ging iets mis, kopieer handmatig: <span>${text}</span>`, 10);
            console.error("Failed to copy text to clipboard:", e);
        }
    }

    onWriteComplete(clipboardElement, clipboardSlug, message, showMessageForSeconds = 4) {
        const onWriteTextElement = this.getOnWriteTextElement(clipboardSlug);
        this.updateUI(clipboardElement, onWriteTextElement, message, showMessageForSeconds);
    }

    getOnWriteTextElement(clipboardSlug) {
        return document.querySelector(`.clipboard__copied-text[data-clipboard-slug='${clipboardSlug}']`);
    }

    updateUI(clipboardElement, onWriteTextElement, message, showMessageForSeconds) {
        const { defaultIconElement, onWriteIconElement } = this.getIconElements(clipboardElement);

        onWriteTextElement.classList.add("clipboard__copied-text--active");
        onWriteTextElement.innerHTML = message;

        defaultIconElement.classList.remove('clipboard__switchable-icon--active');
        onWriteIconElement.classList.add('clipboard__switchable-icon--active');

        setTimeout(() => {
            onWriteTextElement.classList.remove("clipboard__copied-text--active");
            onWriteIconElement.classList.remove('clipboard__switchable-icon--active');
            defaultIconElement.classList.add('clipboard__switchable-icon--active');
            onWriteTextElement.innerHTML = "";
        }, showMessageForSeconds * 1000);
    }

    getIconElements(clipboardElement) {
        return {
            defaultIconElement: clipboardElement.querySelector('.clipboard__switchable-icon-default'),
            onWriteIconElement: clipboardElement.querySelector('.clipboard__switchable-icon-switched')
        };
    }
}